import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';

interface GuestControlsProps {
  hasDemo?: boolean;
  handleNavigateToDemoGame: () => void;
  handlePlay: () => void;
}

export const GuestControls = ({
  hasDemo,
  handleNavigateToDemoGame,
  handlePlay
}: GuestControlsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Button
        onClick={handlePlay}
        title={t('general.signUp') as string}
        mode="button-primary"
        className="h-8 w-full text-xs py-1">
        {t('general.signUp')}
      </Button>
      {hasDemo && (
        <>
          <p className="text-gc_name_game my-1 text-xs font-bold">{t('general.or')}</p>
          <Button
            mode="button-secondary"
            className="text-xs h-8 py-1"
            onClick={handleNavigateToDemoGame}
            title={t('general.demo') as string}
            label={t('general.demo') as string}
          />
        </>
      )}
    </>
  );
};
